import "./publicPath";
import "App/Config/sentry";
import "App/Config";
import "App/Config/muiXLicence";

import React from "react";
import ReactDOM from "react-dom";
import { browserHistory } from "react-router";
import { syncHistoryWithStore } from "react-router-redux";

import RootContainer from "./containers/Root";
import configureStore from "./redux/configureStore";
import routes from "./routes";

// @NOTE: We implement this on development to help hide default react "Warnings" that flood the console

// eslint-disable-next-line no-underscore-dangle
const store = configureStore(window.__INITIAL_STATE__, browserHistory);

const history = syncHistoryWithStore(browserHistory, store);

// avoid ini location null in redux
history.replace(window.location);

ReactDOM.render(
  <RootContainer history={history} routes={routes} store={store} />,
  document.getElementById("root")
);
